import React, { useState, useEffect, useMemo, useCallback, useRef } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const VendorRecoveries = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.VENDOR_RECOVERIES
  const [recoveries, setRecoveries] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [deleteId, setDeleteId] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [search, setSearch] = useState({ vendor: "", cc: "", route: "", amount: "", date: "", remarks: "" })
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vendors, setVendors] = useState([])
  // Summary modal cascading
  const [sPlants, setSPlants] = useState([])
  const [sCenters, setSCenters] = useState([])
  const [sRoutes, setSRoutes] = useState([])
  const [sVendors, setSVendors] = useState([])
  // Import modal
  const [importModal, setImportModal] = useState(false)
  const [importFile, setImportFile] = useState(null)
  const [importing, setImporting] = useState(false)
  const [importResult, setImportResult] = useState(null)
  // Summary modal
  const [summaryModal, setSummaryModal] = useState(false)
  const [summaryLoading, setSummaryLoading] = useState(false)
  // Bulk entry modal
  const [bulkModal, setBulkModal] = useState(false)
  const [bulkRows, setBulkRows] = useState([{ chillingCenter: "", route: "", vendor: "", recoveryDate: "", recoveryAmount: "", remarks: "" }])
  const [bulkLoading, setBulkLoading] = useState(false)
  const [bulkResult, setBulkResult] = useState(null)

  const arr = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []
  const fetchData = useCallback(async () => {
    try {
      const [recRes, coRes, plRes, cenRes, vnRes] = await Promise.all([
        api.get("vendor-recoveries"), api.get("companies"), api.get("plants"), api.get("centers"), api.get("bulk-vendors")
      ])
      const d = recRes.data.data?.data || recRes.data.data || []
      setRecoveries(Array.isArray(d) ? d : [])
      setCompanies(arr(coRes))
      const pl = arr(plRes); setAllPlants(pl); setPlants(pl)
      const cc = arr(cenRes); setAllCenters(cc); setCenters(cc)
      setSPlants(pl); setSCenters(cc)
      setVendors(arr(vnRes))
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])
  const showCompany = companies.length > 1
  // Cascading helpers for summary modal
  const sCompanyChange = async v => { setSCenters(allCenters); setSRoutes([]); setSVendors([]); if(v){try{const r=await api.get("plants-by-company/"+v);setSPlants(arr(r))}catch(e){}}else setSPlants(allPlants) }
  const sPlantChange = async v => { setSRoutes([]); setSVendors([]); if(v){try{const r=await api.get("chillings-by-plant/"+v);setSCenters(arr(r))}catch(e){}}else setSCenters(allCenters) }
  const sCcChange = async v => { setSVendors([]); if(v){try{const r=await api.get("route-cc/"+v);setSRoutes(arr(r))}catch(e){}}else setSRoutes([]) }
  const sRouteChange = async v => { if(v){try{const r=await api.get("bulk-vendors");setSVendors(arr(r))}catch(e){}}else setSVendors([]) }
  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => { try { await api.delete("delete-vendor-recovery/" + deleteId); fetchData() } catch (e) { console.error(e) } }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try { await api.post("delete-multiple-vendor-recoveries", { items: ids }); setCheckedItems({}); setParentChecked(false); fetchData() } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => { setCheckedItems(prev => { const n = { ...prev, [id]: !prev[id] }; setParentChecked(recoveries.length > 0 && recoveries.every(r => n[r.id])); return n }) }
  const handleParentCheckbox = () => { const n = !parentChecked; setParentChecked(n); const items = {}; recoveries.forEach(r => { items[r.id] = n }); setCheckedItems(items) }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const filtered = useMemo(() => {
    return recoveries.filter(item => {
      const vn = (item.vendorName || item.vendor || "").toLowerCase()
      const cc = (item.ccName || item.chillingCenter || "").toLowerCase()
      const rt = (item.routeName || item.route || "").toLowerCase()
      return vn.includes(search.vendor.toLowerCase()) && cc.includes(search.cc.toLowerCase()) &&
        rt.includes(search.route.toLowerCase()) && (item.recoveryAmount || "").toString().includes(search.amount) &&
        (item.recoveryDate || "").includes(search.date) && (item.remarks || "").toLowerCase().includes(search.remarks.toLowerCase())
    })
  }, [recoveries, search])

  const summary = useMemo(() => {
    const p = v => parseFloat(String(v || "0").replace(/,/g, "")) || 0
    let total = 0; filtered.forEach(r => { total += p(r.recoveryAmount) })
    return { count: filtered.length, total }
  }, [filtered])
  const fmtAmt = v => { const n = parseFloat(String(v || "0").replace(/,/g, "")); return isNaN(n) ? "₹0" : "₹" + n.toLocaleString("en-IN") }

  const exportCSV = () => {
    const h = ["S.No", "Vendor", "Chilling Center", "Route", "Recovery Amount", "Recovery Date", "Remarks"]
    const r = filtered.map((rec, i) => [i + 1, rec.vendorName || rec.vendor, rec.ccName || rec.chillingCenter, rec.routeName || rec.route, rec.recoveryAmount, rec.recoveryDate, rec.remarks])
    const csv = [h, ...r].map(r => r.map(c => `"${(c || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n")
    const blob = new Blob([csv], { type: "text/csv" }); const a = document.createElement("a"); a.href = URL.createObjectURL(blob)
    a.download = `vendor_recoveries_${new Date().toISOString().slice(0, 10)}.csv`; a.click()
  }

  const handleImport = async () => {
    if (!importFile) return
    setImporting(true); setImportResult(null)
    try {
      const fd = new FormData(); fd.append("file", importFile)
      const resp = await api.post("import-vendor-recoveries", fd, { headers: { "Content-Type": "multipart/form-data" } })
      setImportResult(resp.data); if (resp.data.success) fetchData()
    } catch (e) { setImportResult({ success: false, message: e.response?.data?.message || "Import failed" }) }
    setImporting(false)
  }

  const downloadSample = async () => {
    try { const r = await api.get("sample-vendor-recoveries-export", { responseType: "blob" }); const u = URL.createObjectURL(new Blob([r.data])); const a = document.createElement("a"); a.href = u; a.download = "vendor_recoveries_sample.csv"; a.click() } catch (e) { console.error(e) }
  }

  const handleSummaryDownload = async (e, v) => {
    setSummaryLoading(true)
    try {
      const resp = await api.post("vendor-recovery-summary-download", v, { responseType: "blob" })
      const u = URL.createObjectURL(new Blob([resp.data])); const a = document.createElement("a"); a.href = u; a.download = "vendor_recovery_summary.csv"; a.click()
    } catch (e) { console.error(e) }
    setSummaryLoading(false); setSummaryModal(false)
  }

  const addBulkRow = () => setBulkRows(prev => [...prev, { chillingCenter: "", route: "", vendor: "", recoveryDate: "", recoveryAmount: "", remarks: "" }])
  const removeBulkRow = i => setBulkRows(prev => prev.filter((_, idx) => idx !== i))
  const updateBulkRow = (i, field, val) => setBulkRows(prev => prev.map((r, idx) => idx === i ? { ...r, [field]: val } : r))

  const handleBulkEntry = async () => {
    setBulkLoading(true); setBulkResult(null)
    try {
      const resp = await api.post("bulk-entry-vendor-recoveries", { entries: bulkRows })
      setBulkResult(resp.data); if (resp.data.success) { fetchData(); setBulkRows([{ chillingCenter: "", route: "", vendor: "", recoveryDate: "", recoveryAmount: "", remarks: "" }]) }
    } catch (e) { setBulkResult({ success: false, message: "Bulk entry failed" }) }
    setBulkLoading(false)
  }

  const removeFilter = () => { setSearch({ vendor: "", cc: "", route: "", amount: "", date: "", remarks: "" }); setShowFilter(!showFilter) }

  const summaryCards = [
    { label: "Total Recoveries", value: summary.count, icon: "fa-list", color: "#6366f1" },
    { label: "Total Amount", value: fmtAmt(summary.total.toString()), icon: "fa-rupee-sign", color: "#ef4444" },
    { label: "Avg Recovery", value: fmtAmt(summary.count ? (summary.total / summary.count).toFixed(0) : "0"), icon: "fa-calculator", color: "#f59e0b" },
    { label: "Vendors", value: new Set(recoveries.map(r => r.vendorName || r.vendor).filter(Boolean)).size, icon: "fa-users", color: "#22c55e" },
  ]

  const iconBtn = (bg, icon, title, onClick, disabled) => (
    <button title={title} onClick={onClick} disabled={disabled}
      style={{ width: "32px", height: "32px", borderRadius: "4px", background: bg, color: "#fff",
        border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", opacity: disabled ? 0.5 : 1 }}>
      <i className={`fas ${icon}`}></i>
    </button>
  )

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>Vendor Recoveries</h4>
            {canAdd(MID) && <Link to="/add-vendor-recovery" title="Add Recovery"
              style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#28a745", color: "#fff",
                display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", textDecoration: "none" }}>
              <i className="fas fa-plus"></i></Link>}
            {canDelete(MID) && iconBtn("#dc3545", "fa-trash", selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete",
              () => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Select at least one item.") }, false)}
            {iconBtn("#0d6efd", "fa-filter", "Toggle Filter", removeFilter, false)}
            {canExport(MID) && iconBtn("#17a2b8", "fa-download", "Export CSV", exportCSV, !filtered.length)}
            {canAdd(MID) && iconBtn("#6f42c1", "fa-file-upload", "Import CSV", () => setImportModal(true), false)}
            {iconBtn("#e67e22", "fa-file-download", "Summary Download", () => setSummaryModal(true), false)}
            {canAdd(MID) && iconBtn("#20c997", "fa-layer-group", "Bulk Entry", () => setBulkModal(true), false)}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search.vendor} onChange={e => setSearch(s => ({ ...s, vendor: e.target.value }))} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i></button>
          </div>
        </div>

        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{ background: "#fff", borderRadius: "10px", padding: "14px 16px", borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i></div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="vendorRecoveriesTbl">
            <thead><tr>
              <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
              <th>S.NO</th><th>Vendor Name</th><th>Chilling Center</th><th>Route</th><th>Recovery Amount</th><th>Recovery Date</th><th>Remarks</th><th>Actions</th>
            </tr></thead>
            <tbody>
              {showFilter && (<tr><td></td><td></td>
                <td><input type="text" className="form-control form-control-sm" placeholder="Vendor..." value={search.vendor} onChange={e => setSearch(s => ({ ...s, vendor: e.target.value }))} /></td>
                <td><select className="form-control form-control-sm" value={search.cc} onChange={e => setSearch(s => ({ ...s, cc: e.target.value }))}><option value="">All</option>{centers.map((c, i) => <option key={i} value={c.name}>{c.name}</option>)}</select></td>
                <td><select className="form-control form-control-sm" value={search.route} onChange={e => setSearch(s => ({ ...s, route: e.target.value }))}><option value="">All</option>{routes.map((r, i) => <option key={i} value={r.routeName}>{r.routeName}</option>)}</select></td>
                <td><input type="text" className="form-control form-control-sm" placeholder="Amount..." value={search.amount} onChange={e => setSearch(s => ({ ...s, amount: e.target.value }))} /></td>
                <td><input type="date" className="form-control form-control-sm" value={search.date} onChange={e => setSearch(s => ({ ...s, date: e.target.value }))} /></td>
                <td><input type="text" className="form-control form-control-sm" placeholder="Remarks..." value={search.remarks} onChange={e => setSearch(s => ({ ...s, remarks: e.target.value }))} /></td>
                <td></td></tr>)}
              {!dataLoaded ? (<tr><td colSpan={9}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>)
              : filtered.length > 0 ? filtered.map((rec, i) => (
                <tr key={rec.id}>
                  <td><input type="checkbox" checked={!!checkedItems[rec.id]} onChange={() => handleCheckbox(rec.id)} /></td>
                  <td>{i + 1}</td><td style={{ fontWeight: "600" }}>{rec.vendorName || rec.vendor}</td><td>{rec.ccName || rec.chillingCenter}</td><td>{rec.routeName || rec.route}</td>
                  <td style={{ fontWeight: "600", color: "#0284c7" }}>{fmtAmt(rec.recoveryAmount)}</td><td>{rec.recoveryDate}</td><td>{rec.remarks || "-"}</td>
                  <td>
                    <div style={{ display: "flex", gap: "4px" }}>
                      {canEdit(MID) && <Link title="Edit" to={"/edit-vendor-recovery/" + rec.id}
                        style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#0d6efd", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                        <i className="fas fa-edit"></i></Link>}
                      {canDelete(MID) && <button title="Delete" onClick={() => { setDeleteId(rec.id); setconfirm_alert(true) }}
                        style={{ width: "28px", height: "28px", borderRadius: "4px", background: "#dc3545", color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}>
                        <i className="fas fa-trash"></i></button>}
                    </div>
                  </td>
                </tr>
              )) : (<tr><td colSpan={9} className="text-center py-4"><i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>No vendor recoveries found</td></tr>)}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Import Modal */}
      <Modal isOpen={importModal} toggle={() => { setImportModal(false); setImportResult(null); setImportFile(null) }} size="md">
        <ModalHeader toggle={() => setImportModal(false)}><i className="fas fa-file-upload me-2"></i>Bulk Import Vendor Recoveries</ModalHeader>
        <ModalBody>
          <button className="btn btn-outline-primary btn-sm mb-3" onClick={downloadSample}><i className="fas fa-download me-1"></i>Download Sample CSV</button>
          <p style={{ fontSize: "13px", color: "#6c757d" }}>Download the sample CSV, fill data, and upload. CC, Route, and Vendor names will be auto-resolved.</p>
          <div className="mb-3"><label className="form-label"><strong>Select CSV File</strong></label>
            <input type="file" className="form-control" accept=".csv,.xlsx,.xls,.txt" onChange={e => { setImportFile(e.target.files[0]); setImportResult(null) }} /></div>
          {importResult && (<div className={`alert alert-${importResult.success || importResult.imported > 0 ? "success" : "danger"}`} style={{ fontSize: "13px" }}>
            <strong>{importResult.message}</strong>
            {importResult.imported > 0 && <div className="mt-1"><span style={{ color: "#28a745" }}>✓ {importResult.imported} imported</span>{importResult.failed > 0 && <span style={{ color: "#dc3545" }}> | ✗ {importResult.failed} failed</span>}</div>}
            {importResult.errors?.length > 0 && <ul className="mt-2 mb-0">{importResult.errors.slice(0, 5).map((e, i) => <li key={i} style={{ color: "#dc3545" }}>{e}</li>)}</ul>}
          </div>)}
          <div className="text-end"><button className="btn btn-primary" onClick={handleImport} disabled={!importFile || importing}>
            {importing ? <><Spinner size="sm" /> Importing...</> : <><i className="fas fa-upload me-1"></i>Import</>}</button></div>
        </ModalBody>
      </Modal>

      {/* Summary Download Modal */}
      <Modal isOpen={summaryModal} toggle={() => setSummaryModal(false)} size="lg">
        <ModalHeader toggle={() => setSummaryModal(false)}><i className="fas fa-file-download me-2"></i>Vendor Recovery Summary Download</ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={handleSummaryDownload}>
            {showCompany && <Row><Col md={6}><div className="mb-3"><AvField type="select" name="company" label="Company" onChange={e=>sCompanyChange(e.target.value)}><option value="">All</option>{companies.map((c,i)=><option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col></Row>}
            <Row>
              <Col md={6}><div className="mb-3"><AvField type="select" name="plant" label="Plant" onChange={e=>sPlantChange(e.target.value)}><option value="">All Plants</option>{sPlants.map((p,i)=><option key={i} value={p.id}>{p.name}</option>)}</AvField></div></Col>
              <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center" onChange={e=>sCcChange(e.target.value)}><option value="">All</option>{sCenters.map((c,i)=><option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col>
            </Row>
            <Row>
              <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route" onChange={e=>sRouteChange(e.target.value)}><option value="">All</option>{sRoutes.map((r,i)=><option key={i} value={r.id}>{r.routeName}</option>)}</AvField></div></Col>
              <Col md={6}><div className="mb-3"><AvField type="select" name="vendor" label="Vendor"><option value="">All</option>{sVendors.map((v,i)=><option key={i} value={v.id}>{v.vendorName}</option>)}</AvField></div></Col>
            </Row>
            <Row>
              <Col md={6}><div className="mb-3"><AvField type="date" name="fromDate" label="From Date *" required /></div></Col>
              <Col md={6}><div className="mb-3"><AvField type="date" name="toDate" label="To Date *" required /></div></Col>
            </Row>
            <div className="text-end"><button type="submit" className="btn btn-primary" disabled={summaryLoading}>
              {summaryLoading ? <><Spinner size="sm" /> Downloading...</> : <><i className="fas fa-download me-1"></i>Download Summary</>}</button></div>
          </AvForm>
        </ModalBody>
      </Modal>

      {/* Bulk Entry Modal */}
      <Modal isOpen={bulkModal} toggle={() => { setBulkModal(false); setBulkResult(null) }} size="xl">
        <ModalHeader toggle={() => setBulkModal(false)}><i className="fas fa-layer-group me-2"></i>Vendor Recovery Bulk Entry</ModalHeader>
        <ModalBody>
          <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
            <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
              <thead style={{ position: "sticky", top: 0, background: "#f8fafc" }}><tr>
                <th>#</th><th>Chilling Center *</th><th>Route *</th><th>Vendor *</th><th>Date *</th><th>Amount *</th><th>Remarks</th><th></th>
              </tr></thead>
              <tbody>
                {bulkRows.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td><select className="form-control form-control-sm" value={row.chillingCenter} onChange={async e => { updateBulkRow(i,"chillingCenter",e.target.value); updateBulkRow(i,"route",""); updateBulkRow(i,"vendor",""); if(e.target.value){try{const r=await api.get("route-cc/"+e.target.value);updateBulkRow(i,"_routes",arr(r))}catch(ex){}}else{updateBulkRow(i,"_routes",[])} }}>
                      <option value="">Select</option>{allCenters.map((c, j) => <option key={j} value={c.id}>{c.name}</option>)}</select></td>
                    <td><select className="form-control form-control-sm" value={row.route} onChange={async e => { updateBulkRow(i,"route",e.target.value); updateBulkRow(i,"vendor",""); if(e.target.value){try{const r=await api.get("bulk-vendors");updateBulkRow(i,"_vendors",arr(r))}catch(ex){}}else{updateBulkRow(i,"_vendors",[])} }}>
                      <option value="">Select</option>{(row._routes||routes).map((r, j) => <option key={j} value={r.id}>{r.routeName}</option>)}</select></td>
                    <td><select className="form-control form-control-sm" value={row.vendor} onChange={e => updateBulkRow(i, "vendor", e.target.value)}>
                      <option value="">Select</option>{(row._vendors||vendors).map((v, j) => <option key={j} value={v.id}>{v.vendorName}</option>)}</select></td>
                    <td><input type="date" className="form-control form-control-sm" value={row.recoveryDate} onChange={e => updateBulkRow(i, "recoveryDate", e.target.value)} /></td>
                    <td><input type="number" className="form-control form-control-sm" placeholder="0.00" value={row.recoveryAmount} onChange={e => updateBulkRow(i, "recoveryAmount", e.target.value)} /></td>
                    <td><input type="text" className="form-control form-control-sm" value={row.remarks} onChange={e => updateBulkRow(i, "remarks", e.target.value)} /></td>
                    <td>{bulkRows.length > 1 && <button className="btn btn-sm btn-outline-danger" onClick={() => removeBulkRow(i)}><i className="fas fa-times"></i></button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button className="btn btn-sm btn-outline-primary mt-2" onClick={addBulkRow}><i className="fas fa-plus me-1"></i>Add Row</button>
          {bulkResult && (<div className={`alert alert-${bulkResult.success ? "success" : "danger"} mt-3`} style={{ fontSize: "13px" }}>
            <strong>{bulkResult.message}</strong>
            {bulkResult.errors?.length > 0 && <ul className="mt-2 mb-0">{bulkResult.errors.map((e, i) => <li key={i} style={{ color: "#dc3545" }}>{e}</li>)}</ul>}
          </div>)}
          <div className="text-end mt-3"><button className="btn btn-primary" onClick={handleBulkEntry} disabled={bulkLoading}>
            {bulkLoading ? <><Spinner size="sm" /> Saving...</> : <><i className="fas fa-save me-1"></i>Save All Entries</>}</button></div>
        </ModalBody>
      </Modal>

      {confirm_alert && <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Recovery deleted.") }}
        onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>}
      {confirm_multiple_alert && <SweetAlert title={`Delete ${selectedCount} items?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Selected recoveries deleted.") }}
        onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>}
      {success_dlg && <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>}
    </>
  )
}
export default VendorRecoveries
